import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const deleteIssueLink = ({ issueLinkId }: { issueLinkId: string }): Promise<void> =>
	performDeleteRequest(`/rest/api/2/issueLink/${issueLinkId}`);
